module.exports = __webpack_public_path__ + "static/media/player_lock2.39f36a69.png";